import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesContext = /*#__PURE__*/createContext(undefined);
export default function PropertiesProvider(t0) {
  "use memo";

  const $ = _c(7);
  const {
    children,
    propertyOverride,
    sortPropertyOverride,
    typeDefinitionOverride
  } = t0;
  let t1;
  if ($[0] !== propertyOverride || $[1] !== sortPropertyOverride || $[2] !== typeDefinitionOverride) {
    t1 = {
      propertyOverride,
      typeDefinitionOverride,
      sortPropertyOverride
    };
    $[0] = propertyOverride;
    $[1] = sortPropertyOverride;
    $[2] = typeDefinitionOverride;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const value = t1;
  let t2;
  if ($[4] !== children || $[5] !== value) {
    t2 = /*#__PURE__*/_jsx(PropertiesContext.Provider, {
      value: value,
      children: children
    });
    $[4] = children;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function useProperties() {
  "use memo";

  const context = useContext(PropertiesContext);
  if (context === undefined) {
    throw new Error("useProperties must be used within a PropertiesProvider");
  }
  return context;
}